import { Action } from '@ngrx/store';
import { Cart } from '../../dto';

export enum CartActionTypes {
  SET_CART = 'SET_CART',
  ADD_CART = 'ADD_CART',
  REMOVE_CART = 'REMOVE_CART',
}

export class SetCart implements Action {
  readonly type = CartActionTypes.SET_CART;
  constructor(public payload: Cart[]) {}
}

export class AddCart implements Action {
  readonly type = CartActionTypes.ADD_CART;
  constructor(public payload: Cart) {}
}

export class RemoveCart implements Action {
  readonly type = CartActionTypes.REMOVE_CART;
  constructor(public payload: number[]) {}
}

export type CartActions = SetCart | AddCart | RemoveCart;
